import React, { useRef } from "react";
import Typography from "@mui/material/Typography";
import "react-medium-image-zoom/dist/styles.css";
import "../JaldiLab.css";
import {
  h1style,
  h2style,
  h3style,
  referenceTootKit,
} from "./ChapterList";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import staffLoungImg from "../../../assets/Images/StaffLoung Image/staffLoung.png";
import { ImageDesc54 } from "../../../utils/tmp/ImageDescription/VwdcID";

const StaffLounge = () => {
  const referencesRef = useRef(null);

  const paraStyle = {
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "27px",
    color: "#555555",
    letterSpacing: "0em",
    textAlign: "justified",
  };

  return (
    <div>
      <Typography>
        <h1 id="StaffLounge" style={h1style}>
          PART C - THE HANDBOOK
        </h1>
        <h2 style={h2style}>
          <span style={{ fontSize: "24px" }}>2. </span>
          ORGANIZATION AND DESIGN OF SPACES OF THE COURT COMPLEX
        </h2>
        <h3 style={h3style}>
          <span style={{ fontSize: "20px" }}>2.5. </span>
          Administrative Wing
        </h3>
        <h4 id="staffLounge" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.5.</span>E. Staff Lounge
        </h4>

        <p style={paraStyle}>
          The staff lounge offers a space for Court staff to take breaks and
          relax, and contributes to maintaining the health and psychological
          well-being of staff while providing a comfortable working environment.
          The lounge must provide seating, tables, and amenities such as coffee
          machines or vending machines. Additional recreational facilities, such
          as games or reading materials, may also be provided. All spaces within
          the Staff Lounge must be designed to be accessible for diverse user
          groups.
        </p>

        <CaptionWithBorders1
          image={[staffLoungImg]}
          isZoom={true}
          caption={"Figure 54: Typical floor plan for the staff lounge"}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc54}
        />
      </Typography>
    </div>
  );
};
export default StaffLounge;
